export default __webpack_public_path__ + "static/Killer-d8933b60fab708585c39062f856606d8.svg";